import React from 'react';

const Flex = ({
  align = 'stretch',
  justify = 'start',
  direction = 'row',
  wrap = 'nowrap',
  gap,
  style,
  children,
  ...rest
}) => {
  const flexStyle = {
    display: 'flex',
    alignItems: align,
    justifyContent: justify,
    flexDirection: direction,
    flexWrap: wrap,
    gap,
    ...style,
  };

  return (
    <div style={flexStyle} {...rest}>
      {children}
    </div>
  );
};

export default Flex;